export const OPPORTUNITY_TAB = {
  PROJECT: 'project',
  BIDDING: 'bidding',
  EXHIBITION: 'exhibition'
}

export const OPPORTUNITY_TAB_LIST = Object.values(OPPORTUNITY_TAB)

export const DEFAULT_OPPORTUNITY_TAB = OPPORTUNITY_TAB.PROJECT

export function normalizeOpportunityTab (tab) {
  if (!tab) return null
  return OPPORTUNITY_TAB_LIST.includes(tab) ? tab : null
}
